module.exports = __webpack_public_path__ + "img/3.ae3ed8dd.png";